import { motion } from "framer-motion";
import { useEffect, useState } from "react";

const DEFAULT_NODE_WIDTH = 45;

const generateSpawnPoint = () => {
  const top = 20 + Math.random() * 40; // 25% to 60%
  const left = 25 + Math.random() * 45; // 30% to 70%
  return { top, left };
};

const getCardRotation = (left) => {
  if (left < 30) return -90;
  if (left > 70) return -25;
  if (left < 50) return -60;
  if (left > 50) return -10;
  return 0;
};

const NodeDash = ({
  cardImages = [],
  itemImages = [],
  spawnRate = 600,
  lifetime = 3500,
}) => {
  const [nodes, setNodes] = useState([]);

  useEffect(() => {
    const spawnNode = () => {
      const id = Math.random().toString(36).substring(2, 9);
      const isItem = Math.random() < 0.4; // 40% items, 60% cards
      const images = isItem ? itemImages : cardImages;
      if (!images.length) return;

      const image = images[Math.floor(Math.random() * images.length)];
      const { top, left } = generateSpawnPoint();
      const rotation = isItem
        ? Math.random() * 360
        : 235 + getCardRotation(left); // angled toward center

      setNodes((prev) => [
        ...prev,
        {
          id,
          isItem,
          image,
          top,
          left,
          rotation,
        },
      ]);

      setTimeout(() => {
        setNodes((prev) => prev.filter((n) => n.id !== id));
      }, lifetime);
    };

    const interval = setInterval(spawnNode, spawnRate);
    return () => clearInterval(interval);
  }, [cardImages, itemImages, spawnRate, lifetime]);

  return (
    <>
      {nodes.map(({ id, top, left, image, isItem, rotation }) => (
        <motion.img
          key={id}
          src={image}
          initial={{
            position: "absolute",
            top: `${top}%`,
            left: `${left}%`,
            width: DEFAULT_NODE_WIDTH,
            opacity: 1,
            scale: 1,
            rotate: rotation,
            zIndex: 2,
          }}
          animate={{
            top: "90%",
            left: "50%",
            opacity: 0,
            scale: 0.2,
            rotate: isItem ? rotation + 720 : rotation, // spin items only
          }}
          transition={{
            duration: isItem ? 4 : 2, // items move slower
            ease: "easeInOut",
          }}
        />
      ))}
    </>
  );
};

export default NodeDash;
